import { isProduction } from "../utils/environment-provider";
import keyMirror from 'keymirror';
import { trackError } from "../../shared/tracking/tracking";

export const logType = keyMirror({
	ERROR: null,
	WARNING: null,
})

export const logError = (message, errorObject, data) => {
	log(logType.ERROR, message, data, errorObject);
}

//ToDo: Substitute this for all logErrors
export const logErrorWithTracking = (errorName, message) => {
	log(logType.ERROR, errorName + ": " + message);
	trackError(errorName, { message })
}

export const logWarning = (message, warningObject, data) => {
	log(logType.WARNING, message, data, warningObject);
}

const log = (typeOfLog, message, data = "", errorObj = "") => {
	let logFunc = () => { }
	switch (typeOfLog) {
		case logType.ERROR:
			logFunc = console.error;
			break;
		case logType.WARNING:
			logFunc = console.warn;
			break;
		default:
			logFunc = console.log;
			break;
	}

	// !isProduction() && logFunc(errorObj, message, data);
	!isProduction() && logFunc(message, '\n', data, '\n', errorObj);
}